/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonExport.vue?vue&type=template&id=4a40d2c3"
import script from "./ButtonExport.ts?vue&type=script&lang=ts&external"
export * from "./ButtonExport.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports